<template>
<div class="jm-md-view" v-html="markdown"></div>
</template>

<script>
import marked from 'marked'

export default {
	name: "JmMarkdown",

	props: {
		content: [ String, Number ]
	},

	computed: {
		markdown () {
			return this.content
				? marked(this.content, {sanitize: true})
				: "";
		}
	}
};
</script>

<style lang="stylus" scoped>
.jm-md-view
	overflow auto
	img
		height auto
		margin-top: 1rem;
		margin-bottom: 1rem;
		border-radius: 5px;
		box-shadow: 0 0 1em gray;
		max-width 95%

</style>



// WEBPACK FOOTER //
// src/components/widgets/ItemViewWidgets/Markdown.vue